import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { hideModalAction, showModalAction } from '@/shared/store/modals/actions';
import { Store } from '@/shared/store';

export const useModal = () => {
    return {
        ...useSelector((state: Store) => ({
            modalName: state.modals.activeModal,
            modalTitle: state.modals.modalTitle,
            modalProps: state.modals.modalProps,
            onClose: state.modals.onClose,
            previousModal: state.modals.previousModal,
        })),
    };
};

export const useHideModal = (onClose?: () => void) => {
    const dispatch = useDispatch();
    const { previousModal } = useSelector((state: Store) => ({
        previousModal: state.modals.previousModal,
    }));

    const handleCloseModal = useCallback(() => {
        if (previousModal) {
            dispatch(
                showModalAction({
                    modalName: previousModal.activeModal,
                    modalTitle: previousModal.modalTitle,
                    modalProps: previousModal.modalProps,
                    previousModal: null,
                }),
            );

            return;
        }
        dispatch(hideModalAction());

        if (onClose) {
            onClose();
        }
    }, [dispatch, onClose]);
    return {
        handleCloseModal,
    };
};
